import { Card, type CardProps } from 'antd'
import clsx from 'clsx'
import { type ReactNode, forwardRef } from 'react'
import './style.scss'

interface CardCustomProps extends Omit<CardProps, 'hoverable'> {
  children: ReactNode
  hoverable?: boolean
  accent?: 'red' | 'blue' | 'none'
  bodyClassName?: string
}

const accentClassMap = {
  none: '',
  red: 'card-accent-red',
  blue: 'card-accent-blue',
}

const UiCard = forwardRef<HTMLDivElement, CardCustomProps>(
  (
    { hoverable = true, accent = 'none', className, bodyClassName, children, style, ...rest },
    ref
  ) => {
    const isFullHeight = style?.height === '100%'

    return (
      <div
        ref={ref}
        className={clsx(
          'card-custom',
          accentClassMap[accent],
          hoverable && 'is-hoverable',
          isFullHeight && 'is-full-height',
          className
        )}
        style={
          isFullHeight
            ? { height: '100%', flex: 1, display: 'flex', flexDirection: 'column' }
            : undefined
        }
      >
        <Card
          bordered={false}
          hoverable={false}
          className={clsx('card-inner', bodyClassName)}
          style={style}
          {...rest}
        >
          {children}
        </Card>
      </div>
    )
  }
)

UiCard.displayName = 'UiCard'
export default UiCard
